import * as React from 'react';
import classNames from 'classnames';
import strings from 'owa-strings/owa-extensibility-strings';
import { AddinIcons } from 'owa-addins-icons';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { TaskPaneErrorType } from 'owa-addins-store';

const styles = require('./TaskPaneError.scss');

interface TaskPaneErrorText {
    title: string;
    description: string;
}

export interface TaskPaneErrorProps {
    errorType: TaskPaneErrorType;
}

export default class TaskPaneError extends React.Component<TaskPaneErrorProps, {}> {
    render() {
        const errorText: TaskPaneErrorText = this.getErrorText(this.props.errorType);

        return (
            <div className={styles.errorContainer}>
                <div className={styles.errorContent}>
                    <Icon className={styles.errorIcon} iconName={AddinIcons.OfficeAddinsLogo} />
                    <span className={classNames([styles.errorTextCommon, styles.errorTextTitle])}>
                        {errorText.title}
                    </span>
                    <span
                        className={classNames([
                            styles.errorTextCommon,
                            styles.errorTextDescription,
                        ])}>
                        {errorText.description}
                    </span>
                </div>
            </div>
        );
    }

    private getErrorText(errorType: TaskPaneErrorType): TaskPaneErrorText {
        switch (errorType) {
            case TaskPaneErrorType.Empty:
                return {
                    title: strings.taskPaneErrorNoItemSelected,
                    description: strings.taskPaneErrorNoItemSelectedDescription,
                };
            case TaskPaneErrorType.Multi:
                return {
                    title: strings.taskPaneErrorMultipleItemsSelected,
                    description: strings.taskPaneErrorMultipleItemsSelectedDescription,
                };
            case TaskPaneErrorType.NotSupported:
                return {
                    title: strings.taskPaneErrorAddinsNotSupported,
                    description: strings.taskPaneErrorAddinsNotSupportedDescription,
                };
            default:
                return {
                    title: null,
                    description: null,
                };
        }
    }
}
